import { DecimalPipe, registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import {
  APP_INITIALIZER,
  ApplicationConfig,
  importProvidersFrom,
  LOCALE_ID,
  provideZoneChangeDetection,
} from '@angular/core';

registerLocaleData(localeFr);

import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withInMemoryScrolling } from '@angular/router';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideToastr } from 'ngx-toastr';
import { provideMarkdown } from 'ngx-markdown';

import { adminRoutes } from './admin-app.routes';
import { adminAuthInterceptor } from './core/auth/admin-auth.interceptor';
import { AdminAuthStorageService } from './core/auth/admin-auth-storage.service';
import { AppNotificationService } from '@core/notifications/app-notification.service';
import { NOTIFICATION_SERVICE } from '@core/notifications/notification.service';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export const adminAppConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    DecimalPipe,

    provideHttpClient(
      withInterceptors([adminAuthInterceptor]),
    ),

    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      adminRoutes,
      withInMemoryScrolling({ scrollPositionRestoration: 'top' }),
    ),

    provideToastr({
      positionClass: 'toast-top-right',
      timeOut: 3000,
      closeButton: true,
      progressBar: true,
    }),

    { provide: LOCALE_ID, useValue: 'fr' },
    { provide: NOTIFICATION_SERVICE, useExisting: AppNotificationService },
    provideMarkdown(),

    // Vérifie le token au démarrage (restauré depuis sessionStorage dans le constructeur)
    {
      provide: APP_INITIALIZER,
      useFactory: (storage: AdminAuthStorageService) => () => {
        // La restauration est synchrone (constructeur du service)
        return Promise.resolve();
      },
      deps: [AdminAuthStorageService],
      multi: true,
    },

    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      }),
    ),
  ],
};
